import {computed} from "vue";

export const isDateNotInFuture = (date) => {
  if (!date) return null;
  return date <= todayDate.value;
};
export const todayDate = computed(() => {
  return new Date().toISOString().split('T')[0];
});
